export default "__VITE_ASSET__DIYS4_dw__"